import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function postCreateReceiptCounter({
  clinic_id,
  receipt_prefix,
  receipt_counter,
}: {
  clinic_id: string;
  receipt_prefix: string;
  receipt_counter: number;
}): Promise<TrystGenericResponse<undefined>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({
      clinic_id,
      receipt_prefix,
      receipt_counter,
    });
    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${TRYST_HOST}/business/receipt/counter-config`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
